<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Отчёт по уведомлениям (Веб Машины)</h2>

          <div class="px-3"></div>

          <v-menu offset-y bottom>
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mx-4"
                label="старт"
                v-model="start"
                v-on="on"
                :disabled="inAction"
                style="max-width: 200px"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              :disabled="inAction" locale="ru" first-day-of-week="1"
              v-model="start" :landscape="true" :reactive="true"
            ></v-date-picker>
          </v-menu>

          <v-menu offset-y bottom>
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mx-3"
                label="финиш"
                v-model="end"
                v-on="on"
                :disabled="inAction"
                style="max-width: 200px"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              :disabled="inAction" locale="ru" first-day-of-week="1"
              v-model="end" :landscape="true" :reactive="true"
            ></v-date-picker>
          </v-menu>

          <v-btn color="primary"
            @click="fetch()"
            :disabled="inAction"
          >
            <template v-if="inAction">
              <v-progress-circular :size="15" indeterminate></v-progress-circular>
            </template>
            <span v-else>Посчитать</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="saveAs" :disabled="inAction || report.length === 0"><v-icon>save</v-icon>Сохранить отчёт в файл csv</v-btn>

        </v-toolbar>
      </v-flex>
      <v-flex class="pa-2" v-if="report.length > 0">
        <v-data-table
          dense
          :headers="headers"
          :items="report"
          item-key="schoolname"
          :items-per-page.sync="itemsPerPage"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:item="props">
            <tr v-if="props.item.schoolname === 'Итого:'">
              <td><b>{{ props.item.schoolname }}</b></td>
              <td><b>{{ props.item.smss }}</b></td>
              <td><b>{{ props.item.emails }}</b></td>
            </tr>
            <tr v-else>
              <td>{{ props.item.schoolname }}</td>
              <td>{{ props.item.smss }}</td>
              <td>{{ props.item.emails }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
const FileSaver = require('file-saver')
async function asyncTimeout (ms) {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(), ms)
  })
}
export default {
  name: 'WmReport',
  data: () => ({
    start: moment().startOf('month').format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD'),
    inAction: false,
    report: [],
    itemsPerPage: -1,
    schools: [
      'Школа 2',
      'Школа 18',
      'Школа 30',
      'Школа 37',
      'Школа 42',
      'Школа 54',
      'Школа 31',
      'Школа 58',
      'Школа 60',
      'Школа 71',
      'Школа 73',
      'Гимназия им Грина',
      'Школа 61',
      'ХТЛ',
      'Школа 62'
    ],
    headers: [
      { text: 'Школа', value: 'schoolname', sortable: false },
      { text: 'Кол-во sms', value: 'smss', sortable: false },
      { text: 'Кол-во e-mail', value: 'emails', sortable: false },
    ],
    totalSmss: 0,
    totalEmails: 0
  }),
  methods: {
    async fetch () {
      try {
        this.inAction = true
        await asyncTimeout(500)
        if (moment(this.end).isBefore(moment(this.start))) {
          const e = new Error('Старт должен быть перед финишем')
          this.$store.dispatch('snack', e)
          throw e
        }
        this.report = []
        await this.fetchReport()
      } catch (e) {
        this.$store.dispatch('snack', e)
        this.report = []
      } finally {
        this.inAction = false
      }
    },
    async fetchReport () {
      this.totalSmss = 0
      this.totalEmails = 0
      for await (let schoolname of this.schools) {
        const emails = (await this.$store.dispatch('sioRequest', {
          topic: 'fetch-wm-report',
          pl: {
            schoolname,
            start: this.start,
            end: this.end,
            transport: 'email'
          }
        })).messages[0].count
        this.totalEmails += parseInt(emails)
        const smss = (await this.$store.dispatch('sioRequest', {
          topic: 'fetch-wm-report',
          pl: {
            schoolname,
            start: this.start,
            end: this.end,
            transport: 'sms'
          }
        })).messages[0].count
        this.totalSmss += parseInt(smss)
        this.report.push({
          schoolname,
          emails,
          smss
        })
      }
      this.report.push({
        schoolname: 'Итого:',
        emails: this.totalEmails,
        smss: this.totalSmss
      })
    },
    getCSV () {
      return 'Школа;Кол-во sms;Кол-во e-mail\r\n' + this.report.map(x => `${x.schoolname};${x.smss};${x.emails}\r\n`).join('')
    },
    saveAs () {
      const file = new File(
        [this.getCSV()],
        `WebMachines-report-${this.start}-${this.end}.csv`,
        { type: 'text/plain;charset=utf-8' }
      )
      FileSaver.saveAs(file)
    }
  },
  watch: {
    start () {
      this.report = []
    },
    end () {
      this.report = []
    }
  }
}
</script>

<style lang="css">
  @media print {
    .hide-on-print {
      display: none
    }
  }
</style>
